// extracted by mini-css-extract-plugin
export var buttonContent = "_2n-0";
export var centered = "_2n-1";
export var centeredFlex = "_2n-2";
export var errorText = "_2n-3";
export var icon = "_2n-4";
export var iconButtonContent = "_2n-5";
export var monospace = "_2n-6";
export var padded = "_2n-7";